import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { getTranslations } from '../components/utils';

export const TranslationsContext = createContext();

export const Translations = ({ children }) => {
  return (
    <TranslationsContext.Provider value={getTranslations()}>
      {children}
    </TranslationsContext.Provider>
  );
};

Translations.propTypes = {
  children: PropTypes.node.isRequired
};
